import Table from "components/tables/table";
import { EntityCollection } from "models/list-user-entity-collection";
import { ListEntity } from "models/list-entity";
import { Fragment, FunctionComponent, useState } from "react";
import { useListUser } from "stores/hooks/list-user";
import { useLocale } from "stores/hooks/locale";
import { ColumnInterface } from "components/tables/interfaces";
import { useList } from "stores/hooks/list";
import { faArrowUpRightFromSquare } from "components/icon-library";
import ViewModal from "./view-modal";
import { addEntityCollectionColumns } from "lib/schema";
import { useTranslate } from "stores/hooks/translation";

interface MultiTableProps {
  listEntity: ListEntity;
  entityCollections: EntityCollection[];
}

const MultiTable: FunctionComponent<MultiTableProps> = ({
  listEntity,
  entityCollections,
}) => {
  const translate = useTranslate();
  const locale = useLocale();
  const list = useList();
  const listUser = useListUser();
  const [view, toggleView] = useState<EntityCollection | undefined>(undefined);

  if (!list || !listUser) {
    return null;
  }

  const columns: ColumnInterface[] = [];
  addEntityCollectionColumns(
    listEntity.schema,
    locale,
    [{ ...listEntity }],
    columns,
    translate,
  );

  return (
    <Fragment>
      <Table
        name={`list-${listUser.list_uuid}-user-${listUser.uuid}-entity-${listEntity.uuid}`}
        columns={columns}
        data={entityCollections}
        editers={[
          {
            onClick: async (item) => toggleView(item),
            icon: faArrowUpRightFromSquare,
          },
        ]}
      />
      {view && (
        <ViewModal
          listEntity={listEntity}
          entityCollection={view}
          onClose={async () => toggleView(undefined)}
        />
      )}
    </Fragment>
  );
};

export default MultiTable;
